/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_TermsInputs */

const en_page_title_terms = /** @type {(inputs: Page_Title_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of use`)
};

const nl_page_title_terms = /** @type {(inputs: Page_Title_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruiksvoorwaarden`)
};

/**
* | output |
* | --- |
* | "Terms of use" |
*
* @param {Page_Title_TermsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_terms = /** @type {((inputs?: Page_Title_TermsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_TermsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_terms(inputs)
	return en_page_title_terms(inputs)
});